import React from 'react';
import { errorIcon, successIcon, infoIcon, warningIcon } from './assets';
import './Notification.css';

export interface Props {
  title?: string;
  message: string;
  type: string;
}

export const Notification = ({ message, type, title }: Props) => {
  let notificationStyle = 'notification';
  let notificationIcon;

  switch (type) {
    case 'error':
      notificationIcon = errorIcon;
      notificationStyle = `${notificationStyle} notification__error`;
      break;
    case 'success':
      notificationIcon = successIcon;
      notificationStyle = `${notificationStyle} notification__success`;
      break;
    case 'warning':
      notificationIcon = warningIcon;
      notificationStyle = `${notificationStyle} notification__warning`;
      break;
    case 'info':
      notificationIcon = infoIcon;
      notificationStyle = `${notificationStyle} notification__info`;
      break;

    // no default
  }

  if (title && message) {
    return (
      <div className={notificationStyle}>
        <div className="notification__icon-wrapper">
          <img className="notification__icon" src={notificationIcon} alt="" />
        </div>
        <div className="notification__message">
          <div className="notification__title">{title}</div>
          <div className="notification__text">{message}</div>
        </div>
      </div>
    );
  }
  return (
    <div className={notificationStyle}>
      <div className="notification__icon-wrapper">
        <img className="notification__icon" src={notificationIcon} alt="" />
      </div>
      <div className="notification__message">
        <div className="notification__text">{message}</div>
      </div>
    </div>
  );
};
